<template>
    <div style="height: 100%">
        <div class="step-card" v-if="!billing">
            <v-skeleton-loader
                type="article, actions"
            ></v-skeleton-loader>
        </div>
        <div class="d-flex flex-column step-card" v-else-if="billing && !billing.payment_method" >
            <div class="d-flex flex-row pb-3">
                <p class="ma-0 fs-16 fw-400">Your credit card is charged only when fulfilling orders placed on external platforms{{ isShopify ? ' (for example Shopify).' : '.'}}</p>
                <v-img max-width="100px" max-height="50px" contain :src="$root.getSrc('default/drop_icons/stripe.png')" alt="Drop" />
            </div>
            <v-form ref="card_form" class="mt-3" >
                <div>
                    <div class="v-input d-flex flex-column theme--light v-text-field v-text-field--is-booted v-text-field--enclosed v-text-field--outlined">
                        <label class="fs-16 fw-600 blue-drop">Card number</label>
                        <div class="v-input__control">
                            <div class="v-input__slot">
                                <fieldset aria-hidden="true"><legend style="width: 0px;"><span>​</span></legend></fieldset>
                                <div class="v-text-field__slot">
                                    <div id="card-number-element" type="text"></div>
                                </div>
                            </div>
                            <div class="v-text-field__details"><div class="v-messages theme--light"><div class="v-messages__wrapper"></div></div></div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6 d-flex flex-column py-0">
                            <label class="fs-16 fw-600 blue-drop">Card name</label>
                            <v-text-field  :rules="[validationRules.required]" :placeholder="$t('Enter card name')" outlined></v-text-field>
                        </div>
                        <div class="col-md-3 d-flex flex-column py-0">
                            <label class="fs-16 fw-600 blue-drop">Expiry date</label>
                            <div class="v-input theme--light v-text-field v-text-field--is-booted v-text-field--enclosed v-text-field--outlined">
                                <div class="v-input__control">
                                    <div class="v-input__slot">
                                        <fieldset aria-hidden="true"><legend style="width: 0px;"><span>​</span></legend></fieldset>
                                        <div class="v-text-field__slot">
                                            <div id="card-expiry-element" type="text"></div>
                                        </div>
                                    </div>
                                    <div class="v-text-field__details"><div class="v-messages theme--light"><div class="v-messages__wrapper"></div></div></div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3 d-flex flex-column py-0">
                            <label class="fs-16 fw-600 blue-drop">Card code</label>
                            <div class="v-input theme--light v-text-field v-text-field--is-booted v-text-field--enclosed v-text-field--outlined">
                                <div class="v-input__control">
                                    <div class="v-input__slot">
                                        <fieldset aria-hidden="true"><legend style="width: 0px;"><span>​</span></legend></fieldset>
                                        <div class="v-text-field__slot">
                                            <div id="card-cvc-element" type="text"></div>
                                        </div>
                                    </div>
                                    <div class="v-text-field__details"><div class="v-messages theme--light"><div class="v-messages__wrapper"></div></div></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="w-100 pink--text">
                        {{stripeValidationError}}
                    </div>
                </div>
                <div class="mt-3 d-flex justify-start">
                    <v-btn :loading="loading" @click="($refs.card_form.validate())? saveCardInfo() : null" x-large color="blue" class="ml-3 small-btns" dark>{{$t('Save')}}</v-btn>
                </div>
            </v-form>

        </div>
        <div class="d-flex align-center justify-center flex-column" style="height: 100%" v-else-if="billing && billing.payment_method">
            <v-img max-height="96px" max-width="96px" :src="$root.getSrc('/default/drop_icons/tick.svg')" contain></v-img>
            <p class="ma-0 pt-5 fs-18 fw-400">
                Your payment card **** **** **** **** {{billing.payment_method.card_last_four}} is saved.
            </p>
            <p class="ma-0 pt-5 fs-18 fw-400">
                You can go to next step.
            </p>

            <secondary-button  class="pt-5" @clickBtn="$emit('changeStep')" :activeButton="true">Next</secondary-button>
        </div>
    </div>
</template>

<script>
import config from "@/config";
import {update} from "@/api/user";
import {getBillings} from "@/api/billings";

export default {
    props:['isShopify'],
    data:() => {
        return{
            steps:3,
            activeStep: 1,
            data:{plan: null},
            billing:null,
            loading:false,
            firstLoading:false,
            stripeAPIToken: config.stripe_key,
            stripe: '',
            elements: '',
            card: '',
            name:'',
            card_object: null,
            stripeValidationError: null,
            user:null,
            accountConntected: false,
        }
    },
    mounted() {
        this.includeStripe('js.stripe.com/v3/', function(){
        }.bind(this) );
        this.getBillings();
    },
    methods:{
        saveCardInfo(){
            this.loading = true;
            this.stripe.confirmCardSetup(
                this.billing.secrete, {
                    payment_method: {
                        card: this.cardNumberElement,
                        billing_details: {
                            name: this.name
                        }
                    }
                }
            ).then(function(result) {
                this.loading = false;
                if (result.error) {
                    this.stripeValidationError = result.error.message;
                } else {
                    this.card_object = result;
                    this.save();
                }
            }.bind(this));
        },
        save(deleted = false){
            var data = {
                ...this.$store.getters.user,
                card: this.card_object
            }
            this.loading = true;
            update(data, this.$store.getters.user.id).then(response => {
                this.$store.dispatch('user/getUser');
                this.getBillings();
                this.$store.commit('app/ADD_MESSAGE', {text: this.$t('User payment method updated successfully'), type:'success'});
            }).catch(e => {

                this.loading = false;
                if(e.response.data && e.response.data.message){
                    this.$store.commit('app/ADD_MESSAGE', {text: e.response.data.message, type:'error'});
                }
            })
        },
        includeStripe( URL, callback ){
            let documentTag = document, tag = 'script',
                object = documentTag.createElement(tag),
                scriptTag = documentTag.getElementsByTagName(tag)[0];
            object.src = '//' + URL;
            if (callback) { object.addEventListener('load', function (e) { callback(null, e); }, false); }
            scriptTag.parentNode.insertBefore(object, scriptTag);

        },
        getBillings(first = true){
            this.loading = true;
            if(first) this.firstLoading = true;
            getBillings().then(res => {
                this.billing = res;
                if(!res.payment_method){
                    setTimeout(()=>{
                        this.configureStripe();
                    },50)
                }

                this.loading = false;
                this.firstLoading = false;
            })
        },
        configureStripe(){
            this.stripe = Stripe( this.stripeAPIToken );

            this.elements = this.stripe.elements();
            var style = {
                base: {
                    color: '#32325d',
                    fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                    fontSmoothing: 'antialiased',
                    fontSize: '16px',
                    '::placeholder': {
                        color: '#aab7c4'
                    }
                },
                invalid: {
                    color: '#fa755a',
                    iconColor: '#fa755a'
                }
            };
            this.cardNumberElement = this.elements.create("cardNumber", {showIcon: true, style: style});
            this.cardNumberElement.mount("#card-number-element");

            this.cardExpiryElement= this.elements.create("cardExpiry", {style: style});
            this.cardExpiryElement.mount("#card-expiry-element");

            this.cardCvcElement= this.elements.create("cardCvc", {style: style});
            this.cardCvcElement.mount("#card-cvc-element");

            this.cardNumberElement.on("change", this.setValidationError);
            this.cardExpiryElement.on("change", this.setValidationError);
            this.cardCvcElement.on("change", this.setValidationError);
        },
        setValidationError(event) {
            this.stripeValidationError = event.error ? event.error.message : "";
        },
    }
}
</script>
<style lang="scss">
.step-indicator{
    height:4px;
    background-color: var(--inputs-color);
    border-radius: 10px;
    min-width: 50px;
    margin: 5px;
}
.step-completed{
    background-color: var(--primary-color);
}
.border-primary{
    border: 1px solid var(--primary-color) !important;
}
#card-number-element, #card-expiry-element, #card-cvc-element{
    min-width: 400px;
    @media screen and (max-width: 800px){
        min-width: 200px;
    }

    min-height: 50px;
    display: flex;
    align-items: center;
    div{
        width: 100%;
    }
}
</style>
